import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import CollapsibleIcon from '@spotahome/ui-library/src/tenant/components/icons/CollapsibleIcon';
import { Collapsible, Link } from '@spotahome/ui-library';

import './GuaranteesCoverMobile.scss';

const GuaranteesCoverMobile = ({ covers, className = '' }) => {
  return (
    <div className={classNames('tenant-guarantees-cover-mobile', className)}>
      {covers.map(({ titleKey, textKey, cta }, index) => (
        <Collapsible
          key={titleKey}
          className={classNames('tenant-guarantees-cover-mobile__item', {})}
          isCollapsed={index !== 0}
          hasIcon
          iconClosed={<CollapsibleIcon collapsed />}
          iconOpened={<CollapsibleIcon collapsed={false} />}
          renderHeader={() => (
            <h3 className="tenant-guarantees-cover-mobile__item__title">
              {trans(titleKey)}
            </h3>
          )}
          renderBody={() => (
            <div className="tenant-guarantees-cover-mobile__item__content">
              <p className="tenant-guarantees-cover-mobile__item__text">
                {trans(textKey)}
              </p>
              {cta && (
                <Link alt href={getPagePath(cta.routeId)} bold>
                  {trans(cta.textKey)}
                </Link>
              )}
            </div>
          )}
        />
      ))}
    </div>
  );
};

GuaranteesCoverMobile.propTypes = {
  covers: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      renderIcon: PropTypes.func.isRequired
    })
  ).isRequired,
  className: PropTypes.string
};

export default GuaranteesCoverMobile;
